import styled, { css } from 'styled-components';
import background from '@/media/onboarding/sitebuilder-v2/bg-gradient-v2.svg';
import backgroundSm from '@/media/onboarding/sitebuilder-v2/bg-gradient-v2-sm.svg';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.white.primary};
    font-family: ${theme.v2.font.family.primary};
    width: 100%;
    min-height: calc(100vh - 82px);
    position: relative;
    display: flex;
    justify-content: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin-top: 1.625rem;
      display: block;
      height: auto;
      min-height: auto;
    }
  `}
`;

export const WaveTop = styled.div`
  ${({ theme }) => css`
    background: url(${background}) no-repeat center top;
    background-size: 100% 224px;
    height: 224px;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10;
    pointer-events: none;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      background: url(${backgroundSm}) no-repeat center top;
      background-size: 100% 110px;
      height: 110px;
    }
  `};
`;

export const CirclesImage = styled.img`
  ${({ theme }) => css`
    height: 330px;
    right: 71px;
    position: absolute;
    top: -50px;
    user-select: none;
    z-index: 1;
    -webkit-user-drag: none;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: 76px;
      top: -38px;
      right: 8px;
      width: 97px;
    }
  `}
`;

export const StarImage = styled.img`
  ${({ theme }) => css`
    height: 410px;
    top: -100px;
    position: absolute;
    left: -126px;
    user-select: none;
    z-index: 11;
    -webkit-user-drag: none;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: 104px;
      left: -40px;
      top: -40px;
    }
  `};
`;

export const AgentWelcomeWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    color: ${theme.v2.colors.neutral.highDark};
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    padding: 0;
    background-color: ${theme.v2.colors.white.primary};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      gap: 24px;
      align-items: center;
      padding-top: 24px;
      max-width: 100%;
      height: auto;
    }
  `};
`;

export const ImageWrapper = styled.div`
  ${({ theme }) => css`
    position: relative;
    width: 50%;
    height: 100%;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center top;
      display: block;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
      height: 400px; /* Altura fixa para mobile */
      flex: none;
      flex: 1;
      
      img {
        height: 100%;
        padding-bottom: 24px;
      }
    }
  `};
`;

export const ContentWrapper = styled.div`
  ${({ theme }) => css`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 16px;
    width: 50%;
    padding: 160px 64px 0 80px;
    overflow-y: auto;
    padding-bottom: 40px;

    @media (max-width: ${theme.v2.breakpoints.lg}) {
       padding: 160px 40px 0 40px; 
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 95%;
      padding: 0px;
      align-items: flex-start;
      gap: 16px;
      max-width: 476px;
      height: auto;
      overflow-y: visible;
    }
  `};
`;

export const Badge = styled.div`
  ${({ theme }) => css`
    display: flex;
    height: 28px;
    width: 150px;
    padding: 0 8px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px;
    background: linear-gradient(90deg, #519AFB 0%, #C58CFB 100%);
    border-radius: 8px;
    color: ${theme.v2.colors.white.primary};
    text-align: center;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    
    img {
      width: 20px;
      height: 20px;
      object-fit: contain;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: fit-content;
      height: 24px;
      font-size: 12px;
      
      img {
        width: 16px;
        height: 16px;
      }
    }
  `};
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    font-size: 28px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
    color: ${theme.v2.colors.brand.primaryExtraDark};
    margin: 0;
    max-width: 480px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      text-align: center;
      font-size: 18px;
      font-weight: 500;
      line-height: 150%;
      max-width: 100%;
    }
  `};
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    text-align: left;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin: 0;
    max-width: 480px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: 16px;
      margin-top: 8px;
      text-align: center;
      max-width: 100%;
    }
  `};
`;

export const BenefitsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 16px;
  width: 100%;
  max-width: 480px;

  @media (max-width: ${({ theme }) => theme.v2.breakpoints.md}) {
    width: 90%;
    gap: 12px;
    margin-top: 16px;
    max-width: 100%;
  }
`;

export const BenefitItem = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    padding: 16px;
    border-radius: 16px;
    border: 1px solid ${theme.v2.colors.brand.primaryUltraLight};
    background: ${theme.v2.colors.white.primary};
    box-shadow: 0 0 2px 0 ${theme.v2.colors.neutral.highMedium};
    width: 100%;
    
    @media (max-width: ${({ theme }) => theme.v2.breakpoints.md}) {
      padding: 12px 16px;
      gap: 12px;
      margin-bottom: 14px;
    }
  `};
`;

export const IconWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    width: 36px;
    height: 36px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border-radius: 8px;
    background: ${theme.v2.colors.brand.primaryUltraLight};
    
    & > svg, & > img {
      width: 20px;
      height: 20px;
    }

    @media (max-width: ${({ theme }) => theme.v2.breakpoints.md}) {
      width: 20px;
      height: 20px;
      padding: 7px;
      gap: 10px;
      
      & > svg, & > img {
        width: 32px;
        height: 32px;
        object-fit: contain;
      }
    }
  `};
`;

export const BenefitText = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    text-align: left;
    font-size: 16px;
    font-weight: 400;
    line-height: 140%;
    flex: 1;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: 16px;
      line-height: 150%;
    }
  `};
`;

export const ButtonWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: 303px;
    margin-top: 24px;

    button {
      width: 100%;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-width: 100%;
      margin-top: 16px;
      margin-bottom: 24px;
      font-size: 18px;
    }
  `};
`;
